import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loader } from '../../../../../common/components';

const ListPage = loadable(() => import('./ListPage'), {
  fallback: <Loader />
});

const ListPageGraph = loadable(() => import('./ListPageGraph'), {
  fallback: <Loader />
});

const OwnRoutes = ({ t }) => {
  return [
    <Route
      key="own_table"
      path="/own/table"
      element={<ListPage t={t} />}
    />,
    <Route
      key="own_graph"
      path="/own/graph"
      element={<ListPageGraph t={t} />}
    />
  ];
};

OwnRoutes.propTypes = {
  t: PropTypes.func
};

export default OwnRoutes;
